import Splide from '@splidejs/splide';
import {Fancybox} from "@fancyapps/ui";

export default class MediaSlider {
  constructor(element) {

    if (element && element.getAttribute('data-initialised') !== 'true') {

      element.setAttribute('data-initialised', 'true')

      new Splide(element, {
        autoWidth: true,
        perPage: 2,
        perMove: 1,
        focus: "center",
        type: 'loop',
        gap: '4rem',
        updateOnMove: true,
        breakpoints: {
          640: {
            perPage: 1,
            autoWidth: false
          }
        }
      }).mount();

      const slides = element.querySelectorAll('div[data-src]');

      slides.forEach(slide => {
        slide.addEventListener('click', () => {
          const {index} = slide.dataset;

          const set = new Set([...[...slides].map(_slide => _slide.dataset.src)])

          new Fancybox(
            [...set].map(src => {
              return {src: src, type: 'image'}
            }),
            {
              startIndex: index - 1
            }
          )
        })
      })
    } else {
      console.log('dont init')
    }
  }
}

